import { ReebeloStoreT } from '@lambda/reebelo';
import {
  Ban,
  CircleDollarSign,
  CircleUser,
  Clock,
  CreditCard,
  Earth,
  FileCheck,
  MapPin,
  MousePointerClick,
  Percent,
  Repeat,
  ShieldCheck,
  Store,
  Undo2,
  Wrench,
} from 'lucide-react';
import { ReactNode } from 'react';

type BenefitsListT = Partial<
  Record<ReebeloStoreT, { content: string; icon: ReactNode }[]>
> & { default: { content: string; icon: ReactNode }[] };

export const benefitsList: BenefitsListT = {
  'reebelo-au': [
    {
      content:
        'For any reason request 1x swap of device for a like-for-like replacement or below refresh services during term. Subject to limits and some exceptions*.',
      icon: <Repeat className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'Service fees apply for each service request & are a % of your device purchase price incl GST (15% for Refresh / 25% for Replacement)',
      icon: <Percent className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'You must reside and have a permanent place of residence, in Australia. Deliveries Australia only.',
      icon: <MapPin className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'Refresh services may include like-for-like replacement of screen, battery (if below 70% capacity) or other components, plus a detailed clean and full diagnostic check.',
      icon: <Wrench className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'The total value of all refresh services capped at original device purchase price. Refresh services not available after a device replacement has been provided.',
      icon: <ShieldCheck className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'No Replacement Device if you have already claimed and received two (2) Device Refresh Services in term.',
      icon: <Ban className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        "In limited cases where we don't provide a replacement , we give a refund via Reebelo Gift Card or Prepaid Mastercard, up to the original device price, less any refresh costs already used.",
      icon: <CreditCard className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'Issued by Reebelo Australia Pty Ltd (ABN 52 641 662 197). Non-transferable. ',
      icon: <FileCheck className="h-5 w-5 shrink-0" />,
    },
  ],
  'reebelo-dev': [
    {
      content:
        'For any reason request 1x swap of device for a like-for-like replacement or below refresh services during term. Subject to limits and some exceptions*.',
      icon: <Repeat className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'Service fees apply for each service request & are a % of your device purchase price incl GST (15% for Refresh / 25% for Replacement)',
      icon: <Percent className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'You must reside and have a permanent place of residence, in Australia. Deliveries Australia only.',
      icon: <MapPin className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'Refresh services may include like-for-like replacement of screen, battery (if below 70% capacity) or other components, plus a detailed clean and full diagnostic check.',
      icon: <Wrench className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'The total value of all refresh services capped at original device purchase price. Refresh services not available after a device replacement has been provided.',
      icon: <ShieldCheck className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'No Replacement Device if you have already claimed and received two (2) Device Refresh Services in term.',
      icon: <Ban className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        "In limited cases where we don't provide a replacement , we give a refund via Reebelo Gift Card or Prepaid Mastercard, up to the original device price, less any refresh costs already used.",
      icon: <CreditCard className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'Issued by Reebelo Australia Pty Ltd (ABN 52 641 662 197). Non-transferable. ',
      icon: <FileCheck className="h-5 w-5 shrink-0" />,
    },
  ],
  'reebelo-ca': [
    {
      content: 'Covers breakdown, physical and liquid damage.',
      icon: <Undo2 className="h-5 w-5 shrink-0" />,
    },
    {
      content: 'Screen, back glass & battery replacement included.',
      icon: <ShieldCheck className="h-5 w-5 shrink-0" />,
    },
    {
      content: 'Fast Repairs or Replacements.',
      icon: <Clock className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        '24/7 online self-service available or call us in business hours.',
      icon: <CircleUser className="h-5 w-5 shrink-0" />,
    },
  ],
  default: [
    {
      content:
        'Extended warranty coverage for defects, malfunctions and breakdowns for up to 24 months.',
      icon: <ShieldCheck className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'Covers extensive accidental damage including cracked screens & spills.',
      icon: <CircleDollarSign className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        'Hassle-free claims, same day service, mail-in or walk-in at 1000+ repair centers.',
      icon: <Store className="h-5 w-5 shrink-0" />,
    },
    {
      content:
        "We'll either replace your device or provide you with the funds to buy another if your device can't be repaired.",
      icon: <Undo2 className="h-5 w-5 shrink-0" />,
    },
    {
      content: 'Open a claim even when overseas with worldwide protection.',
      icon: <Earth className="h-5 w-5 shrink-0" />,
    },
    {
      content: 'File claims via our online claims portal, at your convenience.',
      icon: <MousePointerClick className="h-5 w-5 shrink-0" />,
    },
  ],
};

type ReebeloCareContentT = Partial<Record<ReebeloStoreT, string>> & {
  default: string;
};

export const warrantySlideOverTitles: ReebeloCareContentT = {
  'reebelo-au': 'More information about 24-Month* ReebeloCare Plan',
  'reebelo-dev': 'More information about 24-Month* ReebeloCare Plan',
  'reebelo-ca': 'Add our comprehensive protection plan by Allstate',
  default: 'Safeguard your device with ReebeloCare',
};
